export const truncate = (str, length) => {
  if (!str || str.length <= length) {
    return str;
  }
  const subString = str.substr(0, length);
  return subString.substr(0, subString.lastIndexOf(" ")) + "…";
};

export const titleCase = str => {
  return str
    .toLowerCase()
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const camelCaseToWords = text => {
  return titleCase(text.replace(/([a-z])([A-Z])/g, "$1 $2"));
};

export const isValidEmail = email => {
  const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return re.test(email.toLowerCase());
};

export const isValidUrl = url => {
  const re = /^((sftp|https?):\/\/)?(www\.)?([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?(\?[^\s#]*)?(#[^\s]*)?\b/;
  return re.test(url.toLowerCase());
};
